
const VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
const TEST_ELEMENT = typeof document === "undefined" ? {style: {}} : document.createElement('div');

const TYPE_FUNCTION = 'function';

const { round, abs } = Math;
const { now } = Date;

export {
    VENDOR_PREFIXES,
    TEST_ELEMENT,
    TYPE_FUNCTION,
    round,
    abs,
    now
};
